// "You may also like" ordering on product pages, kept on this device only (localStorage, no app).
// Remembers the fragrance families of the attars a shopper views. Shoppers with history see attars
// from the families they browse most first (shuffled within each level, already-viewed ones later);
// first-time shoppers get a fully random order. Runs before <s-product-carousel> starts.
(() => {
  const root = document.getElementById('product-may-like');
  const track = root?.querySelector('[data-carousel-track]');
  if (!root || !track) return;

  const KEY = 'aq_viewed_attars';
  const FAMILIES = ['musk-attars', 'oud-attars', 'mukhallat-attars', 'floral-attars', 'amber-bakhoor-attars', 'attar-for-men', 'attar-for-women'];
  const familiesOf = (text) => (text || '').split(' ').filter((handle) => FAMILIES.includes(handle));

  let history = [];
  try { history = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { history = []; }
  if (!Array.isArray(history)) history = [];

  const currentHandle = root.dataset.currentHandle;
  const past = history.filter((entry) => entry && entry.h && entry.h !== currentHandle);

  // Save this view (most recent first, last 30 attars).
  const updated = [{ h: currentHandle, f: familiesOf(root.dataset.currentFamilies) }, ...past].slice(0, 30);
  try { localStorage.setItem(KEY, JSON.stringify(updated)); } catch { /* storage full or blocked */ }

  const items = [...track.children];
  const shuffle = (list) => {
    for (let i = list.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [list[i], list[j]] = [list[j], list[i]];
    }
    return list;
  };

  let ordered;
  if (past.length === 0) {
    ordered = shuffle(items);
  } else {
    // Family weights: recent views count more; the attar open now counts too.
    const weights = {};
    updated.forEach((entry, index) => {
      const weight = Math.max(1, 6 - index);
      (entry.f || []).forEach((family) => { weights[family] = (weights[family] || 0) + weight; });
    });
    const viewed = new Set(past.map((entry) => entry.h));
    const scored = items.map((item) => {
      let score = familiesOf(item.dataset.families).reduce((sum, family) => sum + (weights[family] || 0), 0);
      if (viewed.has(item.dataset.handle)) score *= 0.4;
      return { item, score: score + Math.random() * 3 };
    });
    ordered = scored.sort((a, b) => b.score - a.score).map((entry) => entry.item);
  }

  track.append(...ordered);
  root.toggleAttribute('data-ordered', true);
  root.dataset.personalised = past.length > 0 ? 'true' : 'false';
  // Let the carousel recheck its arrows if it started before this ran.
  track.scrollLeft = 0;
  window.dispatchEvent(new Event('resize'));
})();
